// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__37CbX","title":"AfterBackImages_title___5ie2","images":"AfterBackImages_images__3BTi6"};